import { registerComponent } from "helpers";

registerComponent(
  "sort-by-form",
  class SortByForm extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("input", this.handleInput);
    }

    handleInput(event) {
      const formID = event.target.getAttribute("form");
      const form = document.getElementById(formID);
      const sortByChanged = new CustomEvent("input");

      form.dispatchEvent(sortByChanged);
    }
  },
);
